import {PaletteColorsEnum} from '../../../libs/shared/ui/src/styles/paletteModel';
import {makeEnumRuntimeType} from './apiTypes';

// This is in a different file to avoid taking unneeded
// dependencies when only the ENUM is needed.
export const RPaletteColor = makeEnumRuntimeType(PaletteColorsEnum);
